<template>
  <div class="bg-light">
    <loading v-show="load" fullscrean="true"/>
    <div v-if="!load && usuario">
      <top-bar title="Finalizar" event="true" @voltar="voltar"></top-bar>
      <div class="container mt-1">
        <div v-show="step === 1">
          <div class="mb-4" v-if="dados.origin === '3' && dados.modo_pedido === '1'">
            <h6 class="font-weight-bold">Identifique-se</h6>
            <input type="text" class="form-control" placeholder="Digite seu nome aqui" v-model="dados.obs_pedido"/>
          </div>
          <div class="pointer mb-4" v-if="dados.origin === '4'" @click="removerNoLocal()">
            <card-info title="Pedido No Local" class="mb-2" :icon="nolocal.onde_estou === 'Drive-thru' ? 'drive-thru' : 'qrcode'" icon-pos="fa-trash-o">
              <div class="small">{{nolocal.onde_estou}}<span v-if="nolocal.obs_pedido">: {{nolocal.obs_pedido}}</span></div>
            </card-info>
          </div>
          <div class="mb-3" v-else-if="empresaStatus.entregas.length && !dados.nolocal">
            <h6 class="font-weight-bold">Agendar pedido</h6>
            <horarios-entrega ref="modalAgendamento" :empresa="empresaStatus" :agendamento="entrega_agendada" :dados="dados" @changeHorario="changeHorario"/>
          </div>
          <div class="mb-3">
            <div class="alert alert-danger small mb-3" v-if="validarTipoPedido">Selecione uma opção</div>
            <h6 class="font-weight-bold" v-if="dados.origin === '4'">Vai levar ou consumir?</h6>
            <h6 class="font-weight-bold" v-else-if="!pedido_entrega">Retirar ou consumir?</h6>
            <h6 class="font-weight-bold" v-else>{{pedido_local ? 'Entregar, retirar ou consumir?' : 'Entregar ou Retirar pedido?'}}</h6>
            <div id="tipoPedido" class="row no-gutters justify-content-center">
              <div class="pr-1" :class="pedido_local ? 'col-4' : 'col-6'" v-if="dados.origin !== '4'">
                <div class="card text-center pointer text-muted card-pedido" :class="{'border border-primary text-primary': dados.tipo_pedido == 1, 'disabled': !pedido_entrega}" @click="selecionarEntrega('1')">
                  <icon name="delivery" size="28"/>
                  <div class="font-weight-bold small">Entregar</div>
                  <div class="small" v-if="!pedido_entrega"><span class="badge badge-secondary">Indisponível</span></div>
                </div>
              </div>
              <div class="pr-1 pl-1" :class="pedido_local ? 'col-4' : 'col-6'">
                <div class="card text-center pointer text-muted card-pedido" :class="{'border border-primary text-primary': dados.tipo_pedido == 2, 'disabled': !pedido_retirada}" @click="selecionarEntrega('2')">
                  <icon name="viagem" size="28" v-if="dados.origin === '4'"/>
                  <icon name="retirada" size="28" v-else/>
                  <div class="font-weight-bold small">{{ dados.origin === '4' ? 'Levar' : 'Retirar' }}</div>
                  <div class="small" v-if="!pedido_retirada"><span class="badge badge-secondary">Indisponível</span></div>
                </div>
              </div>
              <div class="pl-1" :class="pedido_local ? 'col-4' : 'col-6'" v-if="pedido_local">
                <div class="card text-center pointer text-muted card-pedido" :class="{'border border-primary text-primary': dados.tipo_pedido == 3}" @click="selecionarEntrega('3')">
                  <icon name="local" size="30"/>
                  <div class="font-weight-bold small">Consumir</div>
                </div>
              </div>
            </div>
          </div>

          <div id="tipoEntrega" v-show="dados.tipo_pedido == 1">
            <div class="alert alert-danger d-flex align-items-center mt-3 mb-2 small" v-if="validarEntrega">
              <i class="fa fa-warning mr-2"></i>
              <div>{{validarEntrega}}</div>
            </div>
            <div class="alert alert-warning mt-3 mb-2 small" v-else-if="usuario.id_endereco && usuario.raio_empresa !== '1'">
              <i class="fa fa-warning mr-1"></i> Sentimos muito, mas não entregamos em sua localização
            </div>
            <div class="alert alert-success mt-3 mb-2 small" v-else-if="usuario.entrega_gratis === '1' && (empresa.geo_disabled !== '2' || dados.id_zona)">
              <i class="fa fa-info-circle mr-2"></i>
              <span v-if="dados.valor_frete == 0">Você ganhou <b>Entrega Grátis!</b></span>
              <span v-else-if="empresa.eg_pedido_minimo > 0">Pedido mínimo para entrega grátis: <b>{{ empresa.eg_pedido_minimo | valor }}</b></span>
            </div>
            <div class="p-3 card mb-3" :class="validarEntrega ? ' border-danger' : ''">
              <h6 class="font-weight-bold mb-0">Onde vamos entregar?</h6>
              <div class="small">Local onde será entregue o pedido</div>
              <div v-show="dados.cliente.id_endereco">
                <hr>
                <div class="d-flex">
                  <div class="position-relative mt-1" style="min-width: 52px; width: 52px">
                    <img src="../assets/mapa-min.png" alt="Mapa" style="width: 100%" class="border rounded">
                    <icon class="text-muted" name="address" full="true" size="26" style="width: 26px; position: absolute; top: 12px; left: 0; right: 0; margin: 0 auto"></icon>
                  </div>
                  <div class="ml-2">
                    <h6 class="font-weight-bold m-0">{{dados.cliente.logradouro}}, {{dados.cliente.numero}}</h6>
                    <div class="small">
                      {{dados.cliente.bairro}}, {{dados.cliente.nome_cidade}} - {{dados.cliente.sigla_estado}}<span v-if="dados.cliente.complemento"> ({{dados.cliente.complemento}})</span>
                    </div>
                    <div class="small" v-if="empresa.geo_disabled === '2' && empresa.zonas.length && !dados.id_zona">Selecione a taxa de entrega</div>
                    <div class="small" v-else>
                      <b v-if="valor_frete > 0">{{valor_frete | valor}}</b><b v-else class="text-success">Entrega Grátis</b>
                      <span v-if="dados.zona">/ {{dados.zona.tempo_entrega | tempo}}</span>
                      <span v-else> / {{usuario.tempo_entrega | tempo}}</span>
                      <span v-if="empresa.geo_disabled === '0' && usuario.distance > 100"> / {{usuario.distance | kilometer}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <a href="javascript:" @click="openEndereco()" class="btn btn-outline-primary btn-block">
                {{ dados.cliente.id_endereco ? 'Alterar Endereço' : 'Adicionar Endereço' }}
              </a>
            </div>

            <div id="areaEntrega" v-if="empresa.geo_disabled === '2' && empresa.zonas.length && dados.cliente.id_endereco">
              <div class="alert alert-danger small mb-2" v-if="!!validarTaxa"><i class="fa fa-warning"></i> {{validarTaxa}}</div>
              <div class="card p-3 mb-3">
                <div class="d-flex">
                  <div class="mr-1">
                    <icon name="address" size="22" class="text-primary mr-1"/>
                  </div>
                  <div>
                    <h6 class="font-weight-bold mb-0 text-normal">Área de entrega</h6>
                    <div class="small" v-if="!dados.zona">Selecione uma área de Entrega</div>
                    <div class="small" v-else>{{ dados.zona.nome_zona }}</div>
                  </div>
                </div>
                <div>
                  <hr>
                  <a href="javascript:" class="btn btn-dark btn-block" @click="openZonas()">{{ dados.id_zona ? 'Alterar' : 'Selecionar' }} Área</a>
                </div>
              </div>
            </div>
          </div>

          <div v-show="dados.tipo_pedido == 2 && dados.origin !== '4'">
            <div id="tipoRetirada" class="p-3 card mb-3">
              <div>
                <h6 class="font-weight-bold mb-0">Nosso endereço</h6>
                <div class="small">Local onde deverá ser {{ dados.tipo_pedido == '3' ? 'consumido' : 'retirado' }} o pedido</div>
              </div>
              <hr>
              <div class="d-flex">
                <div class="position-relative mt-1" style="min-width: 52px; width: 52px">
                  <img src="../assets/mapa-min.png" alt="Mapa" style="width: 100%" class="border rounded">
                  <icon class="text-primary" name="address" full="true" size="26" style="width: 26px; position: absolute; top: 12px; left: 0; right: 0; margin: 0 auto"></icon>
                </div>
                <div class="ml-2">
                  <h6 class="font-weight-bold mb-0">{{empresa.endereco}}, {{empresa.numero}}</h6>
                  <div class="small">
                    {{empresa.bairro}} - {{empresa.nome_cidade}}<span v-if="empresa.complemento">, {{empresa.complemento}}</span>
                  </div>
                  <div class="small">
                    <span class="text-success font-weight-bold">Grátis</span>
                    <span v-show="empresaStatus.aberto === '1'"> / {{empresa.media_retirada | tempo}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="dados.tipo_pedido == 3 && dados.origin !== '4'">
            <div class="pointer mb-4" @click="removerNoLocal()" v-if="dados.nolocal">
              <card-info title="Pedido No Local" class="mb-2" :icon="nolocal.onde_estou === 'Drive-thru' ? 'drive-thru' : 'qrcode'" icon-pos="fa-trash-o">
                <div class="small">{{dados.nolocal}}</div>
              </card-info>
            </div>
            <div class="p-3 card mb-3" v-else>
              <div>
                <h6 class="font-weight-bold mb-0">Onde você está?</h6>
                <div class="small">Local onde vai ser {{dados.origin === '4' ? 'entregue' : 'consumido'}} o pedido</div>
              </div>
              <hr>
              <div v-if="nolocal">
                <div class="alert alert-warning d-flex align-items-center mb-2">
                  <i class="fa fa-info-circle mr-2"></i>
                  <div class="small">Selecione a opção "Balcão" se não reservou sua mesa ou não estiver no local onde irá consumir o pedido.</div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label for="ondeEstou" class="font-weight-bold m-0 small">Selecione um local</label>
                      <select id="ondeEstou" class="form-control" v-model="nolocal.onde_estou" @change="nolocal.obs_pedido = ''">
                        <option value="Mesa">Mesa</option>
                        <option value="Balcão">Balcão</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2" v-if="['Mesa','Comanda'].includes(nolocal.onde_estou)">
                      <label for="mesa" class="font-weight-bold m-0 small">Número da {{ nolocal.onde_estou === 'Mesa' ? 'mesa' : 'comanda'}}</label>
                      <input id="mesa" type="number" class="form-control" v-model="nolocal.obs_pedido" placeholder="Ex: 12" required>
                    </div>
                    <div class="form-group mb-2" v-if="nolocal.onde_estou === 'Drive-thru'">
                      <div>
                        <label for="driveThru" class="font-weight-bold m-0 small">Descreva seu automóvel <span class="pl-1 small text-muted">{{nolocal.obs_pedido.length}} de 20</span></label>
                        <input id="driveThru" type="text" class="form-control" v-model="nolocal.obs_pedido" maxlength="20" placeholder="Ex: Uno Mille Cinza (ABC-1234)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="step === 2">
          <div v-if="!['3','4'].includes(dados.origin)">
            <h6 class="font-weight-bold">Forma de pagamento</h6>
            <div id="formaPagamentoContainer" class="card p-3 mb-3">
              <div v-if="dados.pagamento && dados.id_pagamento">
                <div class="d-flex">
                  <div class="mr-1">
                    <img :src="dados.pagamento.img_pagamento" alt="Imagem pagamento" class="mr-1" style="width: 24px">
                  </div>
                  <div>
                    <h6 class="font-weight-bold mb-0">{{dados.pagamento.nome_pagamento}}</h6>
                    <div class="small">
                      <div v-if="dados.troco">Trazer troco pra: {{dados.troco | valor}}</div>
                      <div v-else-if="dados.pagamento.categoria === '5'">Ao finalizar seu pedido você será redirecionado para a tela de pagamento</div>
                      <div v-else-if="dados.id_pagamento === '2'">Efetuar o pagamento conforme combinado</div>
                      <div v-else>Fazer o pagamento no local</div>
                    </div>
                  </div>
                </div>
                <div class="alert alert-warning mb-0 small" style="white-space: pre-line; margin-top: 8px" v-if="dados.pagamento.descricao_pagamento">
                  <i class="fa fa-info-circle mr-1"></i> {{dados.pagamento.descricao_pagamento}}
                </div>
              </div>
              <div v-else>
                <h6 class="font-weight-bold mb-0">Selecione</h6>
                <div class="small">Você precisa selecionar uma forma de pagamento</div>
              </div>
              <div class="alert alert-secondary small mt-2 mb-0" v-if="dados.id_pagamento && dados.pagamento && dados.pagamento.tipo_desconto === '1' && dados.pagamento.minimo_desconto > dados.total">
                Ganhe {{dados.pagamento.valor_taxa * (-1)}}% de desconto em pedidos acima de {{dados.pagamento.minimo_desconto | valor}}
              </div>
              <hr>
              <a href="javascript:" class="btn btn-block btn-dark" @click="alterarPagamento()">
                {{dados.id_pagamento ? 'Alterar Pagamento' : 'Escolher Pagamento'}}
              </a>
            </div>
          </div>
          <div id="obsPedido" class="card p-3 mb-3" v-if="empresa.json_config.obs_pedido === '1' && dados.origin !== '4'">
            <h6 class="font-weight-bold">
              Observações <span class="small">({{ dados.obs_pedido ? dados.obs_pedido.length : 0}} de 100)</span>
              <div class="small">
                Tem observações neste pedido? Adicione aqui
              </div>
            </h6>
            <textarea class="form-control" id="observacoes" rows="3" maxlength="100" placeholder="Descreva aqui as observações deste pedido." style="resize: none" v-model="dados.obs_pedido"></textarea>
          </div>
          <div id="cupomDesconto" class="card p-3 mb-3" :class="{'border-danger': !!validarCupom}">
            <div class="d-flex">
              <div class="mr-1">
                <icon name="cupom" size="24" class="text-primary mr-1"/>
              </div>
              <div>
                <h6 class="font-weight-bold mb-0">{{dados.id_cupom ? dados.cupom.ref_cupom : 'Cupom de desconto'}}</h6>
                <div class="small" v-if="!dados.id_cupom">
                  Tem um cupom? Adicione aqui!
                </div>
                <div class="small" v-else>
                  <b v-if="dados.cupom.tipo === '2'">{{dados.cupom.valor | valor}}</b>
                  <b v-else>{{dados.cupom.valor | percent}}%</b>
                  de desconto em seu pedido
                  <div class="mt-1" v-if="dados.cupom.horario_fim !== '23:59'">
                    <i class="fa fa-clock-o"></i> Somente até às <b>{{dados.cupom.horario_fim}}</b>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-2 mb-0 alert alert-danger small" v-if="!!validarCupom" v-html="validarCupom"></div>
            <hr>
            <a href="javascript:" class="btn btn-primary btn-block" @click="openCupom()">{{ dados.id_cupom ? 'Remover Cupom' : 'Adicionar Cupom' }}</a>
          </div>
          <div class="mb-3" v-if="empresa.fidelidade && empresa.fidelidade.id_fidelidade && empresa.fidelidade.tipo_fidelidade !== '2'">
            <card-info title="Programa de vantagens" icon="pontos">
              <div v-if="empresa.fidelidade.tipo_fidelidade === '1'">
                <div class="small" v-if="dados.total > empresa.fidelidade.valor_ponto">Você ganha <b>1 ponto</b> com este pedido!</div>
                <div class="small" v-else>Compre acima de <b>{{empresa.fidelidade.valor_ponto | valor}} </b> para pontuar</div>
              </div>
              <div v-else>
                <div class="small" v-if="dados.total > empresa.fidelidade.valor_ponto">Você ganha <b>{{(dados.total + parseFloat(cashback) - parseFloat(valor_frete)) / empresa.fidelidade.valor_ponto | pontos}}</b> com este pedido!</div>
                <div class="small" v-else>A cada <b>{{empresa.fidelidade.valor_ponto | valor}} </b> você ganha 1 ponto</div>
              </div>
            </card-info>
          </div>
          <div class="card p-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="mr-1">
                <icon name="sacola" size="24" class="text-primary mr-1"/>
              </div>
              <div>
                <h6 class="font-weight-bold mb-0">Sacola de produtos</h6>
                <div class="small"><router-link :to="`${url}/categorias`" class="text-primary font-weight-bold">Adicionar mais itens</router-link></div>
              </div>
            </div>
          </div>
          <div>
            <h6 class="font-weight-bold">Resumo dos valores</h6>
            <div class="card p-3 mb-4">
              <div class="font-weight-bold">
                <p class="mb-0 text-muted">
                  <span class="float-right">{{dados.total + parseFloat(cashback) - parseFloat(valor_frete) - parseFloat(valor_taxa) | valor}}</span>
                  Subtotal
                </p>
                <div v-if="token">
                  <p class="mb-0 text-muted" v-if="cashback > 0">
                    <span class="float-right">
                      <small v-if="dados.id_cupom" v-show="dados.cupom.tipo === '1'">({{dados.cupom.valor | percent}}%)</small>
                      <small v-else-if="empresa.cashback_delivery > 0">({{empresa.cashback_delivery}}%)</small>
                      (-) {{cashback | valor}}
                    </span>
                    Desconto
                  </p>
                  <div class="mb-0 text-muted" v-show="dados.tipo_pedido == 1">
                    <span class="float-right" v-if="valor_frete > 0">(+) {{valor_frete | valor}}</span>
                    <span class="float-right text-success font-weight-bold" v-else>Grátis</span>
                    Entrega
                    <a href="javascript:" class="text-primary" @click="messageEntrega">
                      <i class="fa fa-question-circle"></i>
                    </a>
                  </div>
                  <p class="mb-0 text-muted" v-if="valor_taxa !== 0">
                    <span class="float-right" v-if="valor_taxa > 0">
                      (+) {{valor_taxa | valor}}
                    </span>
                    <span class="float-right" v-if="valor_taxa < 0">
                      (-) {{valor_taxa * (-1) | valor}}
                    </span>
                    {{ dados.pagamento.tipo_desconto === '1' ? 'Desconto Pagamento' : 'Taxa Pagamento' }}
                    <a href="javascript:" class="text-primary" @click="messageTaxa">
                      <i class="fa fa-question-circle"></i>
                    </a>
                  </p>
                  <p class="mb-0 font-weight-bold" v-if="dados.total > 0">
                    <span class="float-right">{{dados.total | valor}}</span>
                    Total
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="padding-top: 82px">
      <div class="bg-white border-top fixed-bottom fixed-container" v-show="!load && dados.produtos.length > 0">
        <div class="p-2">
          <a href="javascript:" class="btn btn-primary btn-block btn-bottom mx-auto" @click="avancarPedido" style="max-width: 500px">
            <div class="d-flex justify-content-between align-items-center animated bounceIn" v-if="token">
              <div class="text-left" style="width: 25%">
                <icon name="sacola" size="24" full="true"/>
              </div>
              <div class="font-weight-bold" style="width: 40%; white-space: nowrap;" v-if="step < 2">
                Continuar
              </div>
              <div class="font-weight-bold" style="width: 40%; white-space: nowrap;" v-else>
                <span v-if="origin === '3'">{{dados.modo_pedido === '2' ? 'Pagar' : 'Enviar'}} Pedido</span>
                <span v-else>{{empresaStatus.aberto === '1' && !entrega_agendada ? 'Enviar' : 'Agendar'}} Pedido</span>
              </div>
              <div class="text-right small" style="width: 25%">
                <b v-if="dados.total > 0">{{dados.total | valor}}</b>
              </div>
            </div>
            <b v-else>Avançar</b>
          </a>
        </div>
      </div>
    </div>

    <modal-bottom :opened="confirmar">
      <div class="container">
        <h5 class='font-weight-bold mt-2 mb-3 text-center'>Podemos {{dados.id_entrega ? 'agendar' : 'confirmar'}} seu pedido?</h5>
        <div v-if="dados.pagamento && dados.pagamento.categoria === '5'">
          <div class="alert alert-warning px-3 d-flex align-items-center pointer" @click="() => $swal('Somente após confirmado o pagamento que seu pedido será enviado para o nosso estabelecimento!')">
            <i class="fa fa-info-circle" style="margin-right: 11px"></i>
            <div class="small">Você será redirecionado para a tela de pagamento.</div>
          </div>
        </div>
        <hr v-else>
        <div class="mb-4">
          <div class="d-flex align-items-center mb-3" v-if="entrega_agendada">
            <icon name="agendar" size="22" class="mr-2"/>
            <div>
              <h6 class="font-weight-bold mb-0">Agendado</h6>
              <div class="small">{{entrega_agendada.horario_inicio}} - {{entrega_agendada.horario_fim}}</div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-3" v-if="dados.tipo_pedido == 1">
            <icon name="delivery" size="22" class="mr-2"/>
            <div>
              <h6 class="font-weight-bold mb-0">Entregar</h6>
              <div class="small">{{dados.cliente.logradouro}}, {{dados.cliente.numero}}, {{dados.cliente.bairro}}, {{dados.cliente.nome_cidade}} - {{dados.cliente.sigla_estado}}<span v-if="dados.cliente.complemento"> ({{dados.cliente.complemento}})</span></div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-3" v-if="dados.tipo_pedido == 2">
            <icon name="viagem" size="22" class="mr-2" v-if="dados.origin === '4'"/>
            <icon name="address" size="22" class="mr-2" v-else/>
            <div>
              <h6 class="font-weight-bold mb-0">{{dados.origin === '4' ? 'Para Levar' : 'Retirar no local'}}</h6>
              <div class="small" v-if="dados.origin === '4'">{{dados.nolocal}}</div>
              <div class="small" v-else>{{empresa.endereco}}, {{empresa.numero}}, {{empresa.bairro}}, <b>{{empresa.nome_cidade}} - {{empresa.sigla_estado}}</b></div>
            </div>
          </div>
          <div class="d-flex align-items-center mb-3" v-if="dados.tipo_pedido == 3">
            <icon name="local" size="22" class="mr-2"/>
            <div>
              <h6 class="font-weight-bold mb-0">Consumir no Local</h6>
              <div class="small">{{dados.nolocal}}</div>
            </div>
          </div>
          <div v-if="dados.origin !== '4'">
            <div class="d-flex align-items-center mb-3" v-if="dados.cliente.telefone">
              <icon name="cellphone" size="22" class="mr-2"/>
              <div>
                <h6 class="font-weight-bold mb-0">Telefone para contato</h6>
                <div class="small">{{ dados.cliente.telefone | phone}}</div>
              </div>
            </div>
            <div class="d-flex align-items-center" v-if="dados.pagamento">
              <img :src="dados.pagamento.img_pagamento" alt="Imagem pagamento" class="mr-2 rounded" style="width: 22px">
              <div>
                <h6 class="font-weight-bold mb-0">Pagamento</h6>
                <div class="small">{{dados.pagamento.nome_pagamento}} - {{this.dados.total | valor}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button class="btn btn-primary btn-block p-2 mb-2" @click="finalizar" :disabled="btnLoad">
            <span v-show="!btnLoad"><b>Confirmar</b></span>
            <span v-show="btnLoad"><i class="fa fa-spinner fa-spin"></i> <b class="pl-2">Enviando seu pedido</b></span>
          </button>
          <button type="button" class="btn btn-block p-2" @click="confirmar = false" v-show="!btnLoad">
            <span class="font-weight-bold text-primary">Voltar</span>
          </button>
        </div>
      </div>
    </modal-bottom>

    <div id="modalEndereco" class="modal-finalizar" v-show="modalEndereco">
      <div class="modal-finalizar-content">
        <div id="containerEndereco" class="py-4 py-md-3 bg-white shadow-sm">
          <div class="container text-center position-relative">
            <a href="javascript:" @click="closeEndereco" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar">
              <i class="fa fa-chevron-left text-dark"></i>
            </a>
            <h1 class="h6 font-weight-bold m-auto">Endereços</h1>
          </div>
        </div>
        <div class="container-fluid mt-3 mb-4">
          <perfil-endereco ref="endereco" component="true" @atualizar="atualizarEndereco()" @fechar="modalEndereco = false"/>
        </div>
      </div>
    </div>

    <cupom ref="modalCupom" v-if="dados.produtos.length > 0" :dados="dados" @adicionar="adicionarCupom" @cuponsDisponiveis="(cupons) => this.cupons = cupons"/>
    <formas-pagamento ref="modalPagamento" :sacola="dados" v-if="dados" @addPagamento="addPagamento"/>
    <zonas-entregas ref="zonas" :sacola="dados" v-if="dados" @addZona="addZona"/>
  </div>
</template>

<script>
  import BottomBar from '../components/BottomBar'
  import TopBar from '../components/TopBar'
  import Loading from '../components/Loading'
  import CardInfo from '../components/CardInfo'
  import Icon from '../components/Icon'
  import ModalBottom from '../components/ModalBottom'
  import HorariosEntrega from '../components/HorariosEntrega'
  import Cupom from "../components/Cupom";
  import Quantidade from "../components/Quantidade";
  import FormasPagamento from "../components/FormasPagamento";
  import ProdutoConsumo from "../components/ProdutoConsumo";
  import CSacola from "../components/CSacola";
  import ZonasEntregas from "../components/ZonasEntregas";
  import PerfilEndereco from "../pages/PerfilEndereco";

  export default {
    name: 'Finalizar',
    components: {
      PerfilEndereco,
      ZonasEntregas,
      CSacola,
      ProdutoConsumo,
      FormasPagamento,
      Quantidade, Cupom, BottomBar, TopBar, Loading, CardInfo, Icon, ModalBottom, HorariosEntrega},
    data() {
      return {
        token: localStorage.getItem('token'),
        url: '',
        empresaStatus: {
          entregas: []
        },
        dados: {
          cliente: {
            ultimo_pagamento: '1',
            ultima_entrega: '1',
            endereco: {},
          },
          cupom: {},
          id_cupom: '',
          id_pagamento: '',
          tipo_pedido: '',
          id_entrega: null,
          produtos: [],
          valor_frete: 0,
          total: 0,
          obs_pedido: '',
          troco: 0,
          pagamento: {}
        },

        pedido_local: true,
        pedido_entrega: true,
        pedido_retirada: true,
        nolocal: { obs_pedido: '', onde_estou: '' },
        step: 1,
        load: true,
        btnLoad: false,
        confirmar: false,
        validarTipoPedido: false,
        validarCupom: false,
        validarTaxa: false,
        validarEntrega: null,
        cashback: 0,
        valor_frete: 0,
        valor_taxa: 0,
        entrega_agendada: null,
        cupons: [],
        troco: false,

        avancar: false,
        modalEndereco: false,
        editarEndereco: false
      }
    },

    methods: {
      getEmpresa() {
        this.load = true;
        this.entrega_agendada = null;
        this.dados.id_entrega = null;

        this.$helpers.setEmpresaStatus(this, this.empresa, (dados) => {
          if (dados) {
            this.empresaStatus = dados;
            const condition = (this.empresaStatus.ativo === '0' || (this.empresaStatus.aberto === '0' && !this.empresaStatus.entregas.length));

            if (condition) {
              let motivo = null;

              if (this.empresaStatus.aberto === '0' || this.empresaStatus.titulo_pausa) {
                motivo = this.empresaStatus.aberto === '0' ? 'Desculpe, estamos fora do nosso horário de funcionamento.' : `Desculpe, estamos pausados no momento.\nMotivo: ${this.empresaStatus.titulo_pausa}`;
              }

              this.$swal(motivo || "Desculpe, não estamos disponíveis.");
              this.step = 1;
              this.voltar();
              this.load = false;
              return;
            }

            this.$emit('buscarCupons');

            if (['3','4'].includes(this.dados.origin)) {
              this.dados.id_pagamento = '5';

            } else if (this.dados.id_pagamento) {
              this.dados.id_pagamento = !this.empresa.pagamentos.find(p => p.id_pagamento === this.dados.id_pagamento) ? '' : this.dados.id_pagamento;

            } else if (this.dados.cliente.ultimo_pagamento && this.empresa.pagamentos.find(p => p.id_pagamento === this.dados.cliente.ultimo_pagamento)) {
              this.dados.id_pagamento = this.dados.cliente.ultimo_pagamento;
            }

            this.getOperacao();
            this.dados.pagamento = this.dados.id_pagamento ? this.empresa.pagamentos.find(p => p.id_pagamento === this.dados.id_pagamento) : {};
            this.selecionarEntrega(this.dados.tipo_pedido || this.dados.cliente.ultima_entrega || null);
            this.dados.empresa = this.empresa.nome_fantasia;
            this.load = false;

          } else {
            this.load = false;
          }
        });
      },

      getOperacao() {
        this.pedido_entrega = this.empresa.tipo_delivery !== '2' && this.dados.origin !== '4';
        this.pedido_retirada = this.empresa.tipo_delivery !== '3' || this.dados.origin === '4';
        this.pedido_local = !!this.empresa.json_config.pedido_local || this.dados.origin === '4';
      },

      selecionarEntrega(tipo) {
        switch (parseInt(tipo || '0')) {
          case 1:
            this.dados.tipo_pedido = this.pedido_entrega ? '1' : '2';

            if (!this.pedido_entrega) {
              this.$swal('No momento, não estamos realizando entregas de pedidos.');
            }

            break;

          case 3:
            this.dados.tipo_pedido = this.pedido_local ? '3' : (this.pedido_entrega ? '1' : '2');
            break;

          default: {
            this.dados.tipo_pedido = this.pedido_retirada ? '2' : '1';

            if (!this.pedido_retirada) {
              this.$swal('No momento, não estamos aceitando pedidos para retirada no local.');
            }
          }
        }

        this.validarTipoPedido = false;
        this.dados.cliente.ultima_entrega = this.dados.tipo_pedido;
        this.dados.zona = null;

        if (this.dados.id_cupom) {
          const cupom = this.dados.cupom;
          const invalido = (cupom.tipo_delivery > 1 && ((this.dados.tipo_pedido === '1' && cupom.tipo_delivery === '2') || (this.dados.tipo_pedido === '2' && cupom.tipo_delivery === '3')));

          if (invalido) {
            this.$swal('O cupom "' + cupom.ref_cupom + '" foi removido pois não atende as regras do desconto.');
            this.removerCupom();
          }
        }

        if (this.dados.tipo_pedido === '1' && this.dados.cliente.id_endereco && this.empresa.geo_disabled === '2' && this.empresa.zonas.length) {
          this.dados.id_zona = this.dados.id_zona || this.dados.cliente.id_zona || null;
          this.dados.zona = this.dados.id_zona ? (this.empresa.zonas.find(z => z.id_zona === this.dados.id_zona) || null) : null;
        }

        if (!this.dados.zona) {
          this.dados.id_zona = null;
        }

        if (!this.nolocal.onde_estou) {
          this.nolocal.onde_estou = 'Mesa'
        }

        this.totalizar();
        this.salvarSacola();
      },

      salvarSacola() {
        localStorage.setItem('sacola', JSON.stringify(this.dados));
        this.$store.state.sacola = this.dados;
      },

      validarTipoConsumo() {
        let itens = [];
        let tipo_consumo = null;
        let arr = null;

        switch (parseInt(this.dados.tipo_pedido)) {
          case 1:
            arr = ['2','4','6'];
            tipo_consumo = "entregas";
            break;

          case 2:
            arr = ['3','4'];
            tipo_consumo = "retirar no local";
            break

          case 3:
            arr = ['2','3','5'];
            tipo_consumo = "consumo no local";
            break
        }

        if (arr) {
          this.dados.produtos.forEach(p => {
            if (arr.includes(p.produto.tipo_consumo)) {
              itens.push(`- ${p.produto.nome_produto}`);
            }

            if (p.adicionais && p.adicionais.length) {
              const adc = p.adicionais.find(a => arr.includes(a.tipo_consumo));

              if (adc) {
                itens.push(`- Adicional: ${adc.nome_produto}`);
              }
            }

            if (p.divisoes && p.divisoes.length) {
              const div = p.divisoes.find(div => arr.includes(div.tipo_consumo));

              if (div) {
                itens.push(`- Sabor: ${div.nome_produto}`);
              }
            }
          });
        }

        if (itens.length) {
          const el = document.getElementById("reviseSeuPedido");

          if (el) {
            document.getElementById("reviseSeuPedido").scrollIntoView();
          }

          itens = [...new Set(itens)];
          this.$swal(`Os seguintes itens na sua sacola não estão disponíveis para ${tipo_consumo}:\n\n${itens.join('\n')}\n\nPor favor, remova-os antes de enviar seu pedido.`);
          return true;
        }

        return false;
      },

      validarCupomTabela(cupom) {
        if (cupom && cupom.tabelas && cupom.tabelas.length) {
          const tabelas = this.$helpers.getIdsSacola(this.dados);
          const existe = cupom.tabelas.some(t => tabelas.includes(t.id_tabela_preco));

          if ((cupom.modo_produto === '1' && !existe) || (cupom.modo_produto === '2' && existe)) {
            const produtos = cupom.tabelas.map(t => t.nome_produto);
            const modo_produto = cupom.modo_produto === '1' ? "INCLUA em" : "REMOVA da";
            return 'Para utilizar este cupom de desconto <b>, '+ modo_produto +'</b> sua sacola um dos seguintes produtos: ' + produtos.join(" | ");
          }
        }

        return false;
      },

      voltar() {
        if (this.step === 1) {
          this.$router.push(this.url + '/home');
          return;
        }

        window.scrollTo(0,0);
        this.step--;
      },

      avancarPedido() {
        switch (this.step) {
          case 1:
            if (this.empresaStatus.aberto === '0' && !this.entrega_agendada) {
              this.alterarHorario(true);
              return;
            }

            if (!this.dados.tipo_pedido) {
              const elTipo = document.getElementById("tipoPedido")
              window.scrollTo({
                top: elTipo ? (elTipo.offsetTop - 150) : 0,
                left: 0,
                behavior: 'smooth'
              });

              this.validarTipoPedido = true;
              let msgTipo = this.pedido_retirada && this.pedido_entrega && this.pedido_local ? 'entregar, retirar ou consumir' : 'entregar ou retirar'

              if (this.dados.origin === '4' || !this.pedido_entrega) {
                msgTipo = 'levar ou consumir';
              }

              this.$swal("Por favor selecione se vai " + msgTipo + " o pedido");
              return;

            } else {
              this.validarTipoPedido = false;
            }

            this.validarEntrega = null;
            this.validarTaxa = null;

            if (this.dados.tipo_pedido == 1) {
              if (!this.usuario.id_endereco) {
                this.openEndereco(true);
                return;

              } else if (this.empresa.geo_disabled === '0' && !this.dados.cliente.lat_endereco) {
                this.$swal("Por favor edite o endereço e informe um local no mapa.").then(() => {
                  this.openEndereco(true, true);
                });

                return;

              } else if (this.usuario.raio_empresa !== '1') {
                this.validarEntrega = "Sentimos muito, mas não entregamos em sua localização. Cadastre ou altere para um novo endereço.";

              } else if ((this.dados.total + parseFloat(this.cashback) - parseFloat(this.valor_frete)) < this.empresa.pedido_minimo) {
                this.validarEntrega = "Atenção, valor mínimo para entrega: R$" + this.empresa.pedido_minimo + ". Acrescente mais itens à sua sacola ou, se disponível, altere para retirar seu pedido.";

              } else if (this.empresa.limitar_cidade === '1' && this.usuario.id_cidade !== this.empresa.id_cidade) {
                this.validarEntrega = `Sentimos muito, entregamos apenas na cidade de ${this.empresa.nome_cidade} - ${this.empresa.sigla_estado}.`;

              } else if (this.empresa.geo_disabled === '2' && this.empresa.zonas.length && !this.dados.id_zona) {
                this.validarTaxa = "Por favor, selecione a área de entrega";
                this.$helpers.scrollTo('areaEntrega', 120);
                this.openZonas(true);
                return;
              }

              if (this.validarEntrega) {
                this.$swal(this.validarEntrega).then(() => {
                  window.scrollTo({
                    top: document.getElementById("tipoEntrega").offsetTop - 100,
                    left: 0,
                    behavior: 'smooth'
                  });
                });

                return;
              }
            }

            if (!this.dados.cliente.telefone) {
              this.$router.push(this.url + '/perfil/telefone');
              return;
            }

            if (this.empresa.json_config.cpf_pedido && !this.usuario.cpf) {
              this.$router.push(this.url + '/perfil/meus-dados');
              this.$swal("Para realizar o pedido é obrigatório informar um CPF.").then(() => {
                this.$helpers.focusrElement('cpf');
              });

              return;
            }

            if (this.empresa.json_config.cadastro_completo) {
              const incompleto = !this.usuario.data_nascimento || !this.usuario.genero;

              if (incompleto) {
                this.$router.push(this.url + '/perfil/meus-dados');
                this.$swal("Para realizar o pedido é obrigatório completar seu cadastro.").then(() => {
                  this.$helpers.focusrElement('nascimento');
                });
                return;
              }
            }

            // ajustar para voltar na sacola
            if (this.validarTipoConsumo()) {
              return;
            }

            if (this.dados.origin === '4' || (this.dados.tipo_pedido == 3 && !this.dados.nolocal)) {
              if (this.nolocal.onde_estou === 'Mesa' && (!this.nolocal.obs_pedido || isNaN(this.nolocal.obs_pedido) || this.nolocal.obs_pedido <= 0 || this.nolocal.obs_pedido > 10000)) {
                this.$swal("Por favor informe um número válido para a mesa!").then(() => {
                  this.$helpers.focusrElement('mesa');
                });

                return;
              }

              this.dados.nolocal = `${this.nolocal.onde_estou}` + (this.nolocal.obs_pedido ? `: ${this.nolocal.obs_pedido}` : '');
            }

            this.step = 2;
            this.$nextTick(() => {
              window.scrollTo(0,0);
            });

            this.salvarSacola();
            break;

          case 2:
            if (!this.dados.id_pagamento) {
              this.alterarPagamento(false, true);
              return;
            }

            if (!['3','4'].includes(this.dados.origin) && this.dados.id_pagamento === '1' && !this.troco && (!this.dados.troco || this.dados.troco < this.dados.total)) {
              this.alterarPagamento(true, true);
              return;
            }

            if (this.dados.total < 0) {
              this.$swal("Atenção, confira os dados enviados, o valor do seu pedido não poder ser menor que R$ 0,00");
              return;
            }

            if (this.dados.id_cupom) {
              let msgCupom = "";

              if (this.dados.cupom.valor_minimo > 0 && (this.dados.total + parseFloat(this.cashback) - parseFloat(this.dados.valor_frete)) < parseFloat(this.dados.cupom.valor_minimo)) {
                msgCupom += "Pedido mínimo para usar este cupom é: <b>R$ " + this.dados.cupom.valor_minimo + "</b> (Entrega não inclusa).</br>";
              }

              if (this.dados.cupom.tipo_delivery > 1 && ((this.dados.tipo_pedido == 1 && this.dados.cupom.tipo_delivery === '2') || (this.dados.tipo_pedido == 2 && this.dados.cupom.tipo_delivery === '3'))) {
                msgCupom += 'Válido apenas para <b>"' + (this.dados.tipo_pedido == 1 ? "Retiradas de Pedidos no local" : "Entregas de Pedidos") + '"</b>.</br>'
              }

              const msgTabela = this.validarCupomTabela(this.dados.cupom);

              if (msgTabela) {
                msgCupom += msgTabela;
              }

              if (this.dados.cupom.pagamentos && this.dados.cupom.pagamentos.length && !this.dados.cupom.pagamentos.find(pag => pag.id_pagamento === this.dados.id_pagamento)) {
                msgCupom += "Válido apenas para pagamentos em: <b>" + (this.dados.cupom.pagamentos.map(pag => pag.nome_pagamento).join(", ")) + "</b>.</br>";
              }

              if (msgCupom) {
                this.validarCupom = msgCupom;

                window.scrollTo({
                  top: document.getElementById("cupomDesconto").offsetTop - 100,
                  left: 0,
                  behavior: 'smooth'
                });

                this.$swal("Atenção, o cupom informado não é válido para este pedido. Verifique os erros informados ou remova o cupom.");
                return;

              } else {
                this.validarCupom = false;
                this.confirmar = true;
              }

            } else if (this.cupons.length) {
              this.$store.state.load = 'Validando seu pedido';
              const total = this.dados.total + parseFloat(this.cashback) - parseFloat(this.dados.valor_frete);
              const cupons = this.cupons.filter(c => c.automatico === '1' && c.valor_minimo <= total && c.tipo_delivery !== (this.dados.tipo_pedido == 1 ? '2' : '3'));

              if (cupons.length) {
                for (let i = 0; i < cupons.length; i++) {
                  const cupom = cupons[i];
                  const pagValido = (!cupom.pagamentos.length || cupom.pagamentos.find(pag => pag.id_pagamento === this.dados.id_pagamento));
                  let prodInvalido = this.validarCupomTabela(cupom);

                  if (pagValido && !prodInvalido && cupom.pontos === '0') {
                    this.adicionarCupom(cupom, false);
                    break;
                  }
                }
              }

              setTimeout(() => {
                this.$store.state.load = null;
                this.confirmar = true;
              }, 500);

            } else {
              this.confirmar = true;
            }

            break;
        }
      },

      finalizar() {
        if (!this.btnLoad) {
          this.btnLoad = true;
          this.dados.cliente.ultimo_pagamento = this.dados.id_pagamento;
          this.dados.cliente.enderecos = [];
          this.dados.version = 'v2';
          const url = this.$helpers.base_url(this, this.empresa);

          if (this.zap) {
            this.dados.origin = '5';
          }

          this.$http.post(url + this.token + '/pedido', this.dados)
            .then(res => {
              if (res.data && res.data.success) {
                const data = res.data;
                this.load = true;
                this.$store.state.saldoFidelidade = null;
                this.$store.state.pontosSacola = 0;
                this.usuario.ultimo_pagamento = this.dados.id_pagamento;
                this.usuario.ultima_entrega = this.dados.tipo_pedido;

                if (this.dados.id_zona && this.dados.zona) {
                  this.usuario.id_zona = this.dados.id_zona;
                  this.usuario.tempo_entrega = this.dados.zona.tempo_entrega;
                  this.usuario.taxa_entrega = this.dados.zona.taxa_entrega;
                }

                if (this.origin === '3') {
                  this.$router.push('/pedidos/' + data.id_pedido);

                } else {
                  this.$router.push(this.url + '/pedidos');
                  const pagamento = data.status_pagamento;

                  if (this.zap && this.empresa.whatsapp && pagamento === '2') {
                    let bot_telefone = this.zap.bot_telefone ? this.zap.bot_telefone : `55${this.empresa.whatsapp}`;
                    this.$router.push(this.url + `/sucesso#${bot_telefone}`);
                  }

                  this.$helpers.trackPixel(this, 'Purchase', this.empresa, false, { value: this.dados.total, currency: 'BRL' });
                  this.$helpers.googleTag(this, '3', parseFloat(this.dados.total));
                  this.$helpers.trackAnalytics("purchase", {
                    currency: "BRL",
                    value: parseFloat(this.dados.total),
                    transaction_id: data.id_pedido,
                    coupon: this.dados.cupom ? this.dados.cupom.ref_cupom : '',
                    shipping: this.dados.valor_frete,
                    items: this.dados.produtos.map(dados => {
                      return {
                        item_id: dados.produto.id_tabela_preco,
                        item_name: dados.produto.nome_produto,
                        quantity: dados.quantidade
                      }
                    })
                  });
                }

                const origin = this.dados.origin === '4' ? '4' : null;
                this.dados = { origin, produtos: [], nolocal: this.dados.nolocal, expiracao: this.dados.expiracao };
                this.salvarSacola();

              } else {
                console.log(res);
              }

              this.btnLoad = false;
              this.confirmar = false;

            }, res => {
              console.log(res);
              this.btnLoad = false;
              this.confirmar = false;

              if (res.status === 401 && res.data.result !== '') {
                this.$swal(res.data.result + ' ' + res.data.msg).then(() => {
                  localStorage.removeItem('token');
                  this.$store.state.dataUser = {};
                  this.$router.push(this.url + '/perfil');
                });
                return;
              }

              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário').then(() => {
                if (res.data) {
                  if (res.data.cupom) {
                    this.removerCupom();
                  }

                  if (res.data.step == 1) {
                    this.voltar();
                  }

                  if (res.data.reload == 1) {
                    window.location.reload();
                  }
                }
              });

              this.getEmpresa();
              throw new Error(res.bodyText);
            });
        }
      },

      totalizar() {
        let total = 0;
        this.dados.produtos.forEach(p => {
          total += (p.quantidade * parseFloat(p.valor));
        });

        this.cashback = 0;

        if (!this.dados.id_cupom) {
          if (this.empresa.cashback_delivery > 0) {
            this.cashback = (total * (this.empresa.cashback_delivery / 100)).toFixed(2);
            total -= this.cashback;
          }

        } else {
          this.cashback = this.dados.cupom.tipo === '1' ? (total * (this.dados.cupom.valor / 100)).toFixed(2) : parseFloat(this.dados.cupom.valor);
          total -= this.cashback;
        }

        this.valor_frete = 0;

        if (parseInt(this.dados.tipo_pedido) === 1 && (this.empresa.entrega_gratis === '0' || this.empresa.eg_pedido_minimo > (total + parseFloat(this.cashback)) || this.usuario.distance > this.empresa.eg_raio)) {
          const taxa_entrega = this.dados.zona ? this.dados.zona.taxa_entrega : this.dados.cliente.taxa_entrega;
          this.valor_frete = parseFloat(taxa_entrega || '0');
        }

        this.dados.valor_frete = this.valor_frete;
        total += this.valor_frete;

        if (this.dados.origin !== '4') {
          this.valor_taxa = this.calcularTaxa(total);
          this.dados.valor_taxa = this.valor_taxa;
        }

        this.dados.total = total + this.valor_taxa;
      },

      calcularTaxa(total) {
        if (this.dados.pagamento && this.dados.pagamento.id_pagamento && this.dados.pagamento.tipo_desconto > 0) {
          if (this.dados.pagamento.tipo_desconto === '1' && this.dados.pagamento.minimo_desconto > total) {
            return 0;
          }

          return parseFloat((total * (this.dados.pagamento.valor_taxa / 100)).toFixed(2));
        }

        return 0;
      },

      openEndereco(avancar, editar) {
        this.avancar = !!avancar;
        this.dados.tipo_pedido = 1;
        this.salvarSacola();
        this.modalEndereco = true;
        document.body.classList.add("modal-open");
        this.$helpers.scrollTo('containerEndereco');

        if (!this.usuario.id_endereco && !this.usuario.enderecos.length) {
          this.$refs.endereco.cadastrarEndereco();

        } else if (editar) {
          this.$refs.endereco.editarEndereco(this.dados.cliente, false, true);
        }
      },

      closeEndereco() {
        document.body.classList.remove("modal-open");
        this.$refs.endereco.fecharModalEndereco();
        this.modalEndereco = false;
      },

      atualizarEndereco() {
        this.closeEndereco();
        this.validarEntrega = null;
        this.dados.cliente = JSON.parse(JSON.stringify(this.usuario));
        this.dados.id_zona = null;
        this.selecionarEntrega('1');

        if (this.avancar) {
          this.avancarPedido();
        }
      },

      alterarPagamento(troco, finalizar) {
        this.$emit('openModalPagamento', troco, finalizar);
      },

      addPagamento(dados, finalizar) {
        this.dados.id_pagamento = dados.id_pagamento;
        this.dados.troco = dados.troco;
        this.dados.pagamento = this.empresa.pagamentos.find(p => p.id_pagamento === dados.id_pagamento);
        this.troco = true;
        this.totalizar();
        this.salvarSacola();

        if (finalizar) {
          this.avancarPedido();
        }
      },

      alterarHorario(finalizar) {
        this.$emit('openModalHorario', finalizar);
      },

      changeHorario(h, finalizar) {
        if (h && h.id_entrega !== this.dados.id_entrega) {
          this.dados.id_entrega = h.id_entrega;
          this.entrega_agendada = h;

        } else {
          this.dados.id_entrega = null;
          this.entrega_agendada = null;
        }

        if (this.entrega_agendada && finalizar) {
          this.avancarPedido();
        }
      },

      openCupom() {
        if (this.dados.id_cupom) {
          this.$swal({
            text: 'Tem certeza que deseja remover este cupom?',
            buttons: ["Não", "Sim"],
            dangerMode: true

          }).then((r) => {
            if (r) {
              this.removerCupom();
              this.$swal('Cupom removido com sucesso!');
            }
          });

        } else {
          this.$emit('openModalCupom');
        }
      },

      removerCupom() {
        this.validarCupom = false;
        this.dados.id_cupom = null;
        this.dados.cupom = {};
        this.totalizar();
        this.salvarSacola();
      },

      adicionarCupom(c, showMsg) {
        this.dados.id_cupom = c.id_cupom;
        this.dados.cupom = c;
        this.totalizar();
        this.salvarSacola();

        if (showMsg) {
          const msg = 'Cupom: "' + c.ref_cupom + '" adicionado com sucesso!';
          const valorMinimo = this.dados.cupom.valor_minimo > 0 && (this.dados.total + parseFloat(this.cashback) - parseFloat(this.dados.valor_frete)) < parseFloat(this.dados.cupom.valor_minimo);

          if (valorMinimo) {
            this.$swal(msg + " O pedido mínimo para uso é de: R$ " + this.dados.cupom.valor_minimo + " (entrega não inclusa).\n\nPara continuar, adicione mais itens em sua sacola ou remova o cupom.");

          } else if (c.pagamentos.length && !c.pagamentos.find(pag => pag.id_pagamento === this.dados.id_pagamento)) {
            this.$swal(msg + " Este cupom é válido apenas para pagamentos em: " + (c.pagamentos.map(pag => pag.nome_pagamento).join(", ")) + ".\n\nPara continuar, altere o pagamento da sua sacola ou remova o cupom.");

          } else {
            this.$swal(msg);
          }
        }
      },

      openZonas(avancar) {
        this.$refs.zonas.abrirModal(avancar);
      },

      addZona(dados, avancar) {
        this.validarTaxa = null;
        this.dados.id_zona = dados.id_zona;
        this.dados.zona = dados;
        this.totalizar();
        this.salvarSacola();

        if (avancar) {
          this.avancarPedido();
        }
      },

      removerNoLocal() {
        this.$swal({
          text: 'Deseja realmente remover o pedido no local?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.load = true;
            this.dados.origin = this.origin;
            this.dados.id_pagamento = '';
            this.dados.nolocal = null;
            this.nolocal.onde_estou = 'Mesa';
            this.nolocal.obs_pedido = '';
            this.getOperacao();
            this.selecionarEntrega();
            localStorage.removeItem('nolocal');
            this.$helpers.getCardapioEmpresa(this, this.empresa.token, null,() => {
              this.load = false;
            });
          }
        });
      },

      messageEntrega() {
        let message = "";

        if (this.empresa.entrega_gratis === '1' && this.empresa.eg_raio > this.dados.cliente.distance) {
          message = this.empresa.eg_pedido_minimo > 0 ? "Pedido mínimo para entrega grátis: R$ " + this.empresa.eg_pedido_minimo + ". " : "Aproveite sua entrega grátis! ";
        }

        if (this.dados.zona) {
          message += `Área de entrega: ${this.dados.zona.nome_zona}`;

        } else {
          message += "Valor variável baseado na distância do endereço de entrega.";
        }

        this.$swal(message);
      },

      messageTaxa() {
        if (this.dados.pagamento && this.dados.pagamento.tipo_desconto > 0) {
          let message = this.dados.pagamento.tipo_desconto === '1' ? 'Desconto de ' + (this.dados.pagamento.valor_taxa * -1) : 'taxa de ' + this.dados.pagamento.valor_taxa;
          message += "%  para pagamentos realizados via " + this.dados.pagamento.nome_pagamento + '.';
          this.$swal(message);
        }
      },

      atualizarSacola(produtos) {
        this.dados.produtos = produtos;
        const msgInvalida = this.dados.id_cupom ? this.validarCupomTabela(this.dados.cupom) : false;

        if (msgInvalida) {
          this.$swal('O cupom "' + this.dados.cupom.ref_cupom + '" foi removido pois não atende as regras do desconto.');
          this.removerCupom();

        } else {
          this.totalizar();
        }
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      zap() {
        return this.$store.state.zap
      },

      empresa() {
        return this.$store.state.empresa
      },

      base_url() {
        return this.$store.state.base_url
      },
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';

      if (this.token) {
        const sacolaTemp = this.$helpers.parseJSONObject(localStorage.getItem('sacola'));

        if (sacolaTemp && sacolaTemp.produtos.length) {
          if (this.origin !== '3' && !this.usuario.telefone) {
            this.$router.push(this.url + '/perfil/telefone');
            return;
          }

          this.dados = { ...sacolaTemp, id_entrega: null };

          if (!this.dados.valor_taxa) {
            this.dados.valor_taxa = 0;
          }

          this.dados.cliente = JSON.parse(JSON.stringify(this.usuario));
          this.dados.enderecos = [];
          this.nolocal = this.$store.state.nolocal;

          if (this.dados.origin === '4') {
            this.dados.nolocal = null;
          }

          this.getEmpresa();

        } else  {
          this.$router.push(this.url + '/home');
          this.load = false;
        }

      } else {
        this.$swal("Faça seu cadastro ou login para finalizar o pedido").then(() => {
          this.$helpers.focusrElement('telefoneLogin');
        });

        this.$router.push(this.url + '/perfil/cadastro');
      }
    },

    created() {
      window.scrollTo(0,0);
      document.body.classList.remove("modal-open");
    },

    beforeRouteLeave(to, from, next) {
      if (['Categorias','Login', 'Pedidos'].includes(to.name)) {
        document.body.classList.remove("modal-open");
        next();

      } else if (this.$refs.modalCupom && this.$refs.modalCupom.opened) {
        this.$refs.modalCupom.closeModal();
        next(false);

      } else if (this.$refs.modalPagamento && this.$refs.modalPagamento.opened) {
        this.$refs.modalPagamento.closeModal();
        next(false);

      } else if (this.modalEndereco) {
        this.closeEndereco();
        next(false);

      } else if (this.$refs.modalAgendamento && this.$refs.modalAgendamento.opened) {
        this.$refs.modalAgendamento.closeModal();
        next(false);

      } else if (this.step === 2) {
        window.scrollTo(0,0);
        this.step--;
        next(false);

      } else {
        next()
      }
    },

    filters: {
      pontos(valor) {
        if (valor) {
          const v = Math.trunc(valor);
          return v + (v > 1 ? ' pontos' : ' ponto');
        }
      },

      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      }
    }
  }
</script>
<style scoped>
  .card-pedido {
    height: 95px;
    display: flex;
    justify-content: center;
    border-width: 2px!important;
  }

  .card-pedido.disabled {
    background-color: #e9ecef;
  }

  .modal-finalizar {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-finalizar-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 600px;
    height: 80vh;
    position: relative;
    border-radius: 12px;
  }

  #obsPedido textarea {
    border-radius: 12px;
  }

  @media (max-width: 600px) {
    .modal-finalizar-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
    }
  }
</style>
